import { bool, object, shape, string } from 'prop-types';

export default {
  defaultColors: shape({ floatingLabelColor: string, focusColor: string }),
  floatingLabelFocusStyle: object,
  floatingLabelStyle: object,
  isFocused: bool,
  shrink: bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-superselectfield/es/types/floatingLabel.types.js
// module id = 1688
// module chunks = 0